// Module
var code = "<md-input-container class=\"full-width bringoz-select-input\" ng-click=\"$ctrl.onShowPanel($event)\"> <label>{{$ctrl.ngPlaceholder || 'Users' | translate}}</label> <input ng-model=\"$ctrl.selectedText\" ng-class=\"$ctrl.isDisabled ? 'disabled' : 'enabled'\" readonly=\"readonly\"> <span class=\"open-icon\">&#9207;</span> </md-input-container> ";
// Exports
export default code;